import { Chakra } from "@airhelp/react-ui-components";
import type { FormErrorProps } from "./FormError.d";

const { FormErrorMessage, FormControl } = Chakra;

const FormError = ({ formError = false, formErrorText, id }: FormErrorProps) => (
  <FormControl isInvalid={formError} id={id} mt={4}>
    <FormErrorMessage fontSize="lg" color="danger.500">
      {formErrorText}
    </FormErrorMessage>
  </FormControl>
);

export default FormError;
